/* eslint-disable class-methods-use-this */
import store from '@/store';
import router from '@/router';

export default class ResponseInterceptor {
  /**
   * Constructor using axios injection.
   * @param {AxiosInstance} axios
   */
  constructor(axios) {
    axios.interceptors.response.use(
      this.onFulfilled.bind(this),
      this.onRejected.bind(this),
    );
  }

  /**
   * On success.
   * @param {AxiosResponse|Promise<AxiosResponse>} response
   */
  onFulfilled(response) {
    if (response instanceof Promise) {
      return response.then(response2 => this.intercept(response2));
    }
    return this.intercept(response);
  }

  /**
   * On reject.
   * @param {AxiosError} error
   * @returns {Promise<never>}
   */
  onRejected(error) {
    const response = error.response;
    const app = router.app;

    if (response.status === 413) {
      store.dispatch('showError', app.$t('message.payload-too-large'));
    }

    return Promise.reject(error);
  }

  /**
   * @param {AxiosResponse} response
   */
  intercept(response) {
    return Promise.resolve(response);
  }
}



// WEBPACK FOOTER //
// ./src/services/axios-interceptor.js